<a
  appHrefNone
  [ngClass]="{'opacity-0': !isLoggedIn, 'opacity-45': isLoggedIn}"
  class="icon-v2 diamond"
  (click)="openHomeToastr()"
></a>
